
/**
 * This function is called whenever web chat receives a custom response and we need construct the content for web chat
 * to display.
 * 
 * 
 * 
 */ function $d272bc0fe8ff4605$export$e0f19440971a69f3(event, instance) {
    const { element: element, message: message } = event.data;
    const ms = event.data.fullMessage.context.skills["actions skill"].skill_variables.table_results;
    console.log("flag1:", event.data);
    event.data.fullWidth = true;
    element.style.maxWidth = "320px";
    element.style.margin = "0 auto";
    element.style.padding = "0";
    // This will define the main HTML content we want to display in this custom response. We will add the individual
    // carousel items below.
    element.innerHTML = `
    <div>
    <br/>
    <div class="Carousel">
      <div class="swiper">
        <div class="swiper-wrapper"></div>
      </div>
      <div class="Carousel__Navigation" >
        <button type="button" class="Carousel__NavigationButton Carousel__NavigationPrevious cds--btn cds--btn--ghost">
          <svg fill="currentColor" width="16" height="16" viewBox="0 0 32 32" aria-hidden="true"><path d="M20 24L10 16 20 8z"></path></svg>
        </button>
        <div class="Carousel__BulletContainer"></div>
        <button type="button" class="Carousel__NavigationButton Carousel__NavigationNext cds--btn cds--btn--ghost">
          <svg fill="currentColor" width="16" height="16" viewBox="0 0 32 32" aria-hidden="true"><path d="M12 8L22 16 12 24z"></path></svg>
        </button>
      </div>
    </div>
    </div>`;
    // const thumbsUpButton = element.querySelector('.Carousel__ThumbUpButton');
    // const thumbsDownButton = element.querySelector('.Carousel__ThumbDownButton');
    // thumbsUpButton.addEventListener('click', () => {
    //   thumbsUpButton.classList.add('active');
    //   thumbsDownButton.classList.remove('active');
    // });
    // thumbsDownButton.addEventListener('click', () => {
    //   thumbsDownButton.classList.add('active');
    //   thumbsUpButton.classList.remove('active');
    // });
    // Once we have the main HTML, create each of the individual slides that will appear in the carousel.
    const slidesContainer = element.querySelector(".swiper-wrapper");
    $d272bc0fe8ff4605$var$createSlides(slidesContainer, ms, instance);
    // Initialize the Swiper library which is what we are using to control the carousel. We are using a custom pagination
    // element to control pagination and navigation.
    // eslint-disable-next-line no-new
    new Swiper(element.querySelector(".swiper"), {
        modules: [
            Navigation,
            Pagination,
            A11y
        ],
        keyboard: {
            enabled: true
        },
        pagination: {
            el: element.querySelector(".Carousel__BulletContainer"),
            clickable: true,
            bulletClass: "Carousel__Bullet",
            bulletActiveClass: "Carousel__Bullet--selected",
            renderBullet: $d272bc0fe8ff4605$var$renderBullet
        },
        navigation: {
            prevEl: element.querySelector(".Carousel__NavigationPrevious"),
            nextEl: element.querySelector(".Carousel__NavigationNext")
        },
        slidesPerView: "auto",
        spaceBetween: 10,
        centeredSlides: false,
        rewind: true
    });
}
/**
 * This function will create the individual slides to display in the carousel. This will use the "carousel_data" value
 * that is provided as part of the message from the assistant. Each slide will have two buttons. The first button
 * will be a link to another web page. The second button will send a message to the assistant to get more data
 * within web chat for the desired card.
 */ async function $d272bc0fe8ff4605$var$createSlides(slidesContainer, message, webChatInstance) {
    const carouselData = message;
    // Clear old slides (optional)
    slidesContainer.innerHTML = "";
    // Loop through each product card
    carouselData.forEach((cardData)=>{
        const title = cardData.product_name;
        const url = cardData.link;
        const description = "Price : Rs. " + cardData.price;
        const imgLink = cardData.product_images_1_links || "https://img.freepik.com/free-photo/vivid-blurred-colorful-wallpaper-background_58702-2430.jpg?size=626&ext=jpg";
        const cardElement = document.createElement("div");
        cardElement.classList.add("swiper-slide");
        cardElement.innerHTML = `
      <div class="cds--tile Carousel__Card">
        <img class="Carousel__CardImage" src="${imgLink}" />
        <div class="Carousel__CardContent">
          <div class="Carousel__CardText">
            <div class="Carousel__CardTitle">${title}</div>
            <div class="Carousel__Nutrition" style="display:none; margin-top:10px; background:#f9f9f9; border-radius:8px; padding:10px;"></div>
          </div>
          <div class="Carousel__CardButtons">
            <button type="button" class="Carousel__CardButton Carousel__CardButtonIngredient cds--btn cds--btn--primary">
              Ingredient List
            </button>
            <button type="button" class="Carousel__CardButton Carousel__CardButtonTellMe cds--btn cds--btn--primary">
              Tell me more about this
            </button>
          </div>
        </div>
      </div>
    `;
        // "Tell me more about this" -> sends message to assistant
        const tellMeButton = cardElement.querySelector(".Carousel__CardButtonTellMe");
        tellMeButton.addEventListener("click", ()=>{
            webChatInstance.send({
                input: {
                    text: `Tell me about ${title}`
                }
            }, {
                silent: false
            });
        });
        // "Ingredient List" -> fetch from backend API
        const ingredientButton = cardElement.querySelector(".Carousel__CardButtonIngredient");
        const nutritionDiv = cardElement.querySelector(".Carousel__Nutrition");
        ingredientButton.addEventListener("click", async ()=>{
            ingredientButton.textContent = "Loading...";
            try {
                const response = await fetch(`http://0.0.0.0:3001/api/nutrition?item=${encodeURIComponent(title)}`);
                const json = await response.json();
                if (json.success && json.data) {
                    const nutrition = json.data;
                    let html = `<strong>Nutritional Info:</strong><br/>`;
                    html += `<ul style="list-style:none; padding-left:0;">`;
                    for (const [key, value] of Object.entries(nutrition))html += `<li><b>${key}</b>: ${value}</li>`;
                    html += `</ul>`;
                    nutritionDiv.innerHTML = html;
                    nutritionDiv.style.display = "block";
                    //  Hide the ingredient button once data is shown
                    ingredientButton.style.display = "none";
                } else {
                    nutritionDiv.innerHTML = `<span style="color:red;">No data found for ${title}</span>`;
                    nutritionDiv.style.display = "block";
                }
            } catch (err) {
                nutritionDiv.innerHTML = `<span style="color:red;">Error fetching data</span>`;
                nutritionDiv.style.display = "block";
                console.error("Error fetching nutrition:", err);
            } finally{
                ingredientButton.textContent = "Ingredient List";
            }
        });
        slidesContainer.appendChild(cardElement);
    });
}
/**
 * Renders a custom bullet to be displayed in the pagination element.
 */ function $d272bc0fe8ff4605$var$renderBullet(_, className) {
    return `<button class="${className} cds--btn cds--btn--ghost" type="button"></button>`;
}


// Global variables
let $06091b3cdcba2dc1$var$serviceTokens;
let $06091b3cdcba2dc1$var$webChatInstance;
let $06091b3cdcba2dc1$var$mediaRecorder;
let $06091b3cdcba2dc1$var$audioChunks = [];
let $06091b3cdcba2dc1$var$isRecording = false;
let $06091b3cdcba2dc1$var$selectedLanguage = "en";
let $06091b3cdcba2dc1$var$audioQueue = [];
let $06091b3cdcba2dc1$var$isPlayingAudio = false;
let $06091b3cdcba2dc1$var$currentAudio = null;
// Global variable to track the mute state
let $06091b3cdcba2dc1$var$isMuted = true;
// Function to handle the mute toggle
function $06091b3cdcba2dc1$var$toggleMute() {
    $06091b3cdcba2dc1$var$isMuted = !$06091b3cdcba2dc1$var$isMuted;
    document.querySelector(".muteButton").innerHTML = $06091b3cdcba2dc1$var$getMuteButtonHTML($06091b3cdcba2dc1$var$isMuted);
    console.log($06091b3cdcba2dc1$var$isMuted ? "TTS Muted" : "TTS Unmuted");
    // Stop audio if muting
    if ($06091b3cdcba2dc1$var$isMuted && $06091b3cdcba2dc1$var$currentAudio) {
        $06091b3cdcba2dc1$var$currentAudio.pause();
        $06091b3cdcba2dc1$var$currentAudio.currentTime = 0;
        $06091b3cdcba2dc1$var$isPlayingAudio = false;
        $06091b3cdcba2dc1$var$currentAudio = null;
    }
}
// Function to get the mute button HTML
// function getMuteButtonHTML(isMuted) {
//     let buttonContent;
//     if (isMuted) {
//         // Speaker off icon
//         buttonContent = `
//             <svg  viewBox="0 0 24 24" fill="none">
//                 <path d="M16 8.82V5a1 1 0 0 0-1.707-.707L9.586 9H6a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h3.586l4.707 4.707A1 1 0 0 0 16 19v-3.82l4.293 4.293 1.414-1.414L3.707 2.293 2.293 3.707 16 17.414V8.82Z" fill="currentColor"/>
//             </svg>
//             <span>Unmute TTS</span>
//         `;
//     } else {
//         // Speaker on icon
//         buttonContent = `
//             <svg  viewBox="0 0 24 24" fill="none">
//                 <path d="M15 5v14a1 1 0 0 1-1.707.707L9.586 15H6a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1h3.586l3.707-3.707A1 1 0 0 1 15 5Zm4.95 1.05-1.414 1.414A7.003 7.003 0 0 1 20 12a7.003 7.003 0 0 1-1.464 4.536l1.414 1.414A8.963 8.963 0 0 0 22 12a8.963 8.963 0 0 0-2.05-5.95Zm-2.828 2.828-1.415 1.414A3.001 3.001 0 0 1 17 12a3.001 3.001 0 0 1-.293 1.293l1.415 1.415A4.978 4.978 0 0 0 19 12a4.978 4.978 0 0 0-1.878-3.121Z" fill="currentColor"/>
//             </svg>
//             <span>Mute TTS</span>
//         `;
//     }
//     return buttonContent;
// }
// Update the getMuteButtonHTML function to use matching SVG styling
function $06091b3cdcba2dc1$var$getMuteButtonHTML(isMuted) {
    let buttonContent;
    if (isMuted) // Speaker off icon - matching record button style
    buttonContent = `
            <svg width="16" height="16" viewBox="0 0 24 24" fill="#393939" xmlns="http://www.w3.org/2000/svg">
                <path d="M16 8.82V5a1 1 0 0 0-1.707-.707L9.586 9H6a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h3.586l4.707 4.707A1 1 0 0 0 16 19v-3.82l4.293 4.293 1.414-1.414L3.707 2.293 2.293 3.707 16 17.414V8.82Z"/>
            </svg>
            <span style="font-size: 13px;">Unmute</span>
        `;
    else // Speaker on icon - matching record button style
    buttonContent = `
            <svg width="16" height="16" viewBox="0 0 24 24" fill="#393939" xmlns="http://www.w3.org/2000/svg">
                <path d="M15 5v14a1 1 0 0 1-1.707.707L9.586 15H6a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1h3.586l3.707-3.707A1 1 0 0 1 15 5Zm4.95 1.05-1.414 1.414A7.003 7.003 0 0 1 20 12a7.003 7.003 0 0 1-1.464 4.536l1.414 1.414A8.963 8.963 0 0 0 22 12a8.963 8.963 0 0 0-2.05-5.95Zm-2.828 2.828-1.415 1.414A3.001 3.001 0 0 1 17 12a3.001 3.001 0 0 1-.293 1.293l1.415 1.415A4.978 4.978 0 0 0 19 12a4.978 4.978 0 0 0-1.878-3.121Z"/>
            </svg>
            <span style="font-size: 13px;">Mute</span>
        `;
    return buttonContent;
}
function $06091b3cdcba2dc1$var$generateTextFromMessage(message) {
    return message.output.generic.map((message)=>message.text).join(" ");
}
// Function to handle the message receive event
function $06091b3cdcba2dc1$var$handleMessageReceive(event) {
    console.log("handleMessageReceive", event);
    const synthText = $06091b3cdcba2dc1$var$generateTextFromMessage(event.data);
    console.log("event.data in receive:", event.data);
    console.log("synthdata:", synthText);
    // Only process TTS if not muted
    if (!$06091b3cdcba2dc1$var$isMuted) // Send synthText to TTS API
    fetch("https://speech-service.1zdn21fdio1u.us-south.codeengine.appdomain.cloud/tts/", {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            text: synthText
        })
    }).then((response)=>response.blob()).then((blob)=>{
        // Stop current audio if any
        if ($06091b3cdcba2dc1$var$currentAudio) {
            $06091b3cdcba2dc1$var$currentAudio.pause();
            $06091b3cdcba2dc1$var$currentAudio.currentTime = 0;
        }
        // Clear existing audio queue
        $06091b3cdcba2dc1$var$audioQueue = [];
        // Replace with only the latest audio
        $06091b3cdcba2dc1$var$audioQueue.push(blob);
        $06091b3cdcba2dc1$var$playNextAudio();
    }).catch((error)=>{
        console.error("Error fetching audio:", error);
    });
}
// Global feedback list
let $06091b3cdcba2dc1$var$feedbackList = [];
function $06091b3cdcba2dc1$var$handleFeedbackButtons(event) {
    setTimeout(()=>{
        const carousels = document.querySelectorAll(".WACWidget__MarkdownP");
        const lastCarousel = carousels[carousels.length - 1];
        if (!lastCarousel || lastCarousel.parentElement.querySelector(".feedback-buttons")) return;
        // Create feedback container
        const feedbackContainer = document.createElement("div");
        feedbackContainer.className = "feedback-buttons feedback-center";
        feedbackContainer.innerHTML = `
      <button class="thumb-btn" style="text-align: center;" data-feedback="positive">\u{1F44D}</button>
      <button class="thumb-btn" style="text-align: center;" data-feedback="negative">\u{1F44E}</button>
    `;
        // Add CSS (only once)
        if (!document.getElementById("feedback-style")) {
            const style = document.createElement("style");
            style.id = "feedback-style";
            style.innerHTML = `
        .feedback-buttons.feedback-center {
          display: flex;
          justify-content: center;
          gap: 10px;
          margin-top: 10px;
          font-size: 16px;
          font-weight: bold;     /* makes text bold */
          font-style: italic;
        }
        .thumb-btn {
          background-color: #f4f4f4;
          border: 1px solid #ccc;
          border-radius: 8px;
          padding: 6px 10px;
          cursor: pointer;
          font-size: 18px;
          transition: all 0.3s ease;
        }
        .thumb-btn:hover {
          background-color: #e0e0e0;
          transform: scale(1.1);
        }
       /* Center the Export button */
        .export-btn {
        display: block;
        margin: 20px auto; /* centers horizontally */
        background-color: #fff;
        border: 1.5px solid #ccc;
        border-radius: 20px;
        cursor: pointer;
        padding: 6px 10px;
        font-size: 16px;
        transition: all 0.2s ease;
        text-align: center;
        }

        .export-btn:hover {
        background-color: #f0f0f0;
        border-color: #999;
        }
        .feedback-buttons.feedback-center.thank-you{
        font-weight: bold;   /* Bold */
        font-style: italic;  /* Italic */
        color: #0072C3;      /* Optional: color to differentiate */
        font-size: 16px;     /* Optional: bigger text */
        margin-top: 10px;        /* Space above to separate from response */
        text-align: center;
}

      `;
            document.head.appendChild(style);
        }
        // Append thumbs below carousel
        lastCarousel.parentElement.appendChild(feedbackContainer);
        // Handle feedback click
        feedbackContainer.addEventListener("click", (e)=>{
            if (e.target.dataset.feedback) {
                const feedbackType = e.target.dataset.feedback;
                const messageText = lastCarousel.innerText || "Carousel message";
                $06091b3cdcba2dc1$var$feedbackList.push({
                    message: messageText,
                    feedback: feedbackType,
                    timestamp: new Date().toISOString()
                });
                console.log("Feedback stored:", $06091b3cdcba2dc1$var$feedbackList);
                //sendFeedbackToProxy(feedbackType, messageText);
                feedbackContainer.classList.add("thank-you");
                feedbackContainer.innerHTML = `<b><i>Thanks for your feedback! \u{1F64F}</i></b>`;
            }
        });
    }, 500);
}
// ==== Google Sheets Integration ====
// Sends feedback to Google Sheet
function $06091b3cdcba2dc1$var$sendFeedbackToProxy(feedbackType, messageText) {
    const payload = {
        message: messageText,
        feedback: feedbackType
    };
    // Replace the URL with your Node proxy
    fetch("http://localhost:3001/send-feedback", {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify(payload)
    }).then((response)=>response.text()).then((result)=>{
        console.log("\u2705 Feedback sent via proxy:", result);
    }).catch((error)=>{
        console.error("\u274C Error sending feedback via proxy:", error);
    });
}
function $06091b3cdcba2dc1$var$playNextAudio() {
    if ($06091b3cdcba2dc1$var$audioQueue.length === 0) {
        $06091b3cdcba2dc1$var$isPlayingAudio = false;
        return;
    }
    // Stop and clean up current audio if it's already playing
    if ($06091b3cdcba2dc1$var$currentAudio) {
        $06091b3cdcba2dc1$var$currentAudio.pause();
        $06091b3cdcba2dc1$var$currentAudio.currentTime = 0;
        $06091b3cdcba2dc1$var$currentAudio = null;
    }
    const blob = $06091b3cdcba2dc1$var$audioQueue.shift();
    const audioUrl = URL.createObjectURL(blob);
    $06091b3cdcba2dc1$var$currentAudio = new Audio(audioUrl);
    if ($06091b3cdcba2dc1$var$isMuted) {
        // If muted, skip playback
        $06091b3cdcba2dc1$var$isPlayingAudio = false;
        return;
    }
    $06091b3cdcba2dc1$var$isPlayingAudio = true;
    $06091b3cdcba2dc1$var$currentAudio.onended = ()=>{
        $06091b3cdcba2dc1$var$isPlayingAudio = false;
        $06091b3cdcba2dc1$var$playNextAudio();
    };
    $06091b3cdcba2dc1$var$currentAudio.onerror = (error)=>{
        console.error("Error playing audio:", error);
        $06091b3cdcba2dc1$var$isPlayingAudio = false;
        $06091b3cdcba2dc1$var$playNextAudio();
    };
    $06091b3cdcba2dc1$var$currentAudio.play().catch((error)=>{
        console.error("Error starting audio playback:", error);
        $06091b3cdcba2dc1$var$isPlayingAudio = false;
        $06091b3cdcba2dc1$var$playNextAudio();
    });
}
// Function to add the mute/unmute button
function $06091b3cdcba2dc1$var$addMuteButton(instance) {
    const button = document.createElement("button");
    button.classList.add("muteButton");
    button.innerHTML = $06091b3cdcba2dc1$var$getMuteButtonHTML($06091b3cdcba2dc1$var$isMuted);
    button.onclick = $06091b3cdcba2dc1$var$toggleMute;
    // Matching styling with record button
    button.style.borderRadius = "999px";
    button.style.padding = "6px 12px";
    button.style.border = "2px solid #393939"; // Darker border color for mute button
    button.style.backgroundColor = "#FFFFFF";
    button.style.color = "#393939"; // Dark text to match border
    button.style.fontWeight = "500";
    button.style.fontSize = "13px";
    button.style.display = "inline-flex";
    button.style.alignItems = "center";
    button.style.justifyContent = "center";
    button.style.gap = "6px";
    button.style.cursor = "pointer";
    button.style.boxShadow = "0 1px 2px rgba(0, 0, 0, 0.08)";
    button.style.minWidth = "80px";
    button.style.width = "100px";
    button.style.maxWidth = "120px";
    button.style.whiteSpace = "nowrap";
    button.style.overflow = "hidden";
    button.style.textOverflow = "ellipsis";
    button.style.margin = "5px";
    instance.writeableElements.beforeInputElement.appendChild(button);
}
function $06091b3cdcba2dc1$var$sendTextToAssistant(text) {
    const sendObject = {
        input: {
            text: text,
            language: $06091b3cdcba2dc1$var$selectedLanguage
        }
    }; // Pass selected language
    const sendOptions = {
        silent: false
    };
    $06091b3cdcba2dc1$var$webChatInstance.send(sendObject, sendOptions);
}
function $06091b3cdcba2dc1$var$onStartRecord() {
    navigator.mediaDevices.getUserMedia({
        audio: true
    }).then((stream)=>{
        $06091b3cdcba2dc1$var$mediaRecorder = new MediaRecorder(stream);
        $06091b3cdcba2dc1$var$mediaRecorder.start();
        $06091b3cdcba2dc1$var$mediaRecorder.ondataavailable = (event)=>{
            $06091b3cdcba2dc1$var$audioChunks.push(event.data);
        };
        $06091b3cdcba2dc1$var$mediaRecorder.onstop = ()=>{
            const audioBlob = new Blob($06091b3cdcba2dc1$var$audioChunks, {
                type: "audio/wav"
            });
            // Log the real MIME type of the blob
            console.log(audioBlob.type);
            const formData = new FormData();
            formData.append("file", audioBlob, "recording.wav");
            fetch("https://speech-service.1zdn21fdio1u.us-south.codeengine.appdomain.cloud/stt/", {
                method: "POST",
                body: formData
            }).then((response)=>response.json()).then((data)=>{
                const text = data.text;
                $06091b3cdcba2dc1$var$sendTextToAssistant(text);
            }).catch((error)=>{
                console.error("Error:", error);
            });
            $06091b3cdcba2dc1$var$audioChunks = [];
        };
    }).catch((error)=>{
        console.error("Error accessing microphone:", error);
    });
}
function $06091b3cdcba2dc1$var$onStopRecord() {
    if ($06091b3cdcba2dc1$var$mediaRecorder) $06091b3cdcba2dc1$var$mediaRecorder.stop();
}
function $06091b3cdcba2dc1$var$setButtonState(localIsRecording) {
    $06091b3cdcba2dc1$var$isRecording = localIsRecording;
    document.querySelector(".RecordButton").innerHTML = $06091b3cdcba2dc1$var$getButtonHTML($06091b3cdcba2dc1$var$isRecording);
}
function $06091b3cdcba2dc1$var$getButtonHTML(isRecording) {
    let buttonContent;
    const icon = `
        <svg width="16" height="16" viewBox="0 0 32 32" fill="#0072C3" xmlns="http://www.w3.org/2000/svg">
            <path d="M23,14v3A7,7,0,0,1,9,17V14H7v3a9,9,0,0,0,8,8.94V28H11v2H21V28H17V25.94A9,9,0,0,0,25,17V14Z" />
            <path d="M16,22a5,5,0,0,0,5-5V7A5,5,0,0,0,11,7V17A5,5,0,0,0,16,22Z" />
        </svg>
    `;
    const startIcon = `
        <svg width="16" height="16" viewBox="0 0 32 32" fill="#0072C3" xmlns="http://www.w3.org/2000/svg">
            <path d="M23,14v3A7,7,0,0,1,9,17V14H7v3a9,9,0,0,0,8,8.94V28H11v2H21V28H17V25.94A9,9,0,0,0,25,17V14Z"/>
            <path d="M16,22a5,5,0,0,0,5-5V7A5,5,0,0,0,11,7V17A5,5,0,0,0,16,22ZM13,7a3,3,0,0,1,6,0V17a3,3,0,0,1-6,0Z"/>
        </svg>
    `;
    buttonContent = isRecording ? `${icon}<span style="font-size: 13px;">Stop</span>` : `${startIcon}<span style="font-size: 13px;">Record</span>`;
    return buttonContent;
}
function $06091b3cdcba2dc1$var$onButtonClick() {
    $06091b3cdcba2dc1$var$setButtonState(!$06091b3cdcba2dc1$var$isRecording);
    if ($06091b3cdcba2dc1$var$isRecording) $06091b3cdcba2dc1$var$onStartRecord();
    else $06091b3cdcba2dc1$var$onStopRecord();
}
function $06091b3cdcba2dc1$var$addRecordButton(instance) {
    const button = document.createElement("button");
    button.classList.add("RecordButton");
    button.innerHTML = $06091b3cdcba2dc1$var$getButtonHTML(false); // Make sure getButtonHTML also returns smaller SVG/text
    button.onclick = $06091b3cdcba2dc1$var$onButtonClick;
    // Styling for smaller button
    button.style.borderRadius = "999px";
    button.style.padding = "6px 12px"; // Reduced padding
    button.style.border = "2px solid #0072C3"; // Slightly thinner border
    button.style.backgroundColor = "#FFFFFF";
    button.style.color = "#0072C3";
    button.style.fontWeight = "500";
    button.style.fontSize = "13px"; // Smaller font size
    button.style.display = "inline-flex";
    button.style.alignItems = "center";
    button.style.justifyContent = "center";
    button.style.gap = "6px"; // Less spacing between icon and text
    button.style.cursor = "pointer";
    button.style.boxShadow = "0 1px 2px rgba(0, 0, 0, 0.08)";
    button.style.minWidth = "80px"; // Optional: fix minimum size
    button.style.width = "100px"; // Optional: fixed width
    button.style.maxWidth = "120px"; // Optional: prevent too wide
    button.style.whiteSpace = "nowrap"; // Prevent wrapping
    button.style.overflow = "hidden";
    button.style.textOverflow = "ellipsis";
    button.style.margin = "5px";
    instance.writeableElements.beforeInputElement.appendChild(button);
}
function $06091b3cdcba2dc1$var$addLanguageToggle(instance) {
    const toggleContainer = document.createElement("div");
    toggleContainer.classList.add("toggle-container");
    toggleContainer.innerHTML = `
        <span>English &nbsp;</span>
        <label class="toggle">
          <input type="checkbox" id="languageToggle">
          <span class="slider round"></span>
        </label>
        <span> &nbsp; \u{939}\u{93F}\u{928}\u{94D}\u{926}\u{940}</span>
      `;
    const languageToggle = toggleContainer.querySelector("#languageToggle");
    languageToggle.onchange = (event)=>{
        $06091b3cdcba2dc1$var$selectedLanguage = event.target.checked ? "hi" : "en";
        console.log($06091b3cdcba2dc1$var$selectedLanguage);
    };
    instance.writeableElements.beforeInputElement.appendChild(toggleContainer);
}
async function $06091b3cdcba2dc1$var$onLoad(instance) {
    $06091b3cdcba2dc1$var$webChatInstance = instance;
    // Stop audio when assistant is restarted
    instance.on({
        type: "restart",
        handler: ()=>{
            if ($06091b3cdcba2dc1$var$currentAudio) {
                $06091b3cdcba2dc1$var$currentAudio.pause();
                $06091b3cdcba2dc1$var$currentAudio.currentTime = 0;
                $06091b3cdcba2dc1$var$currentAudio = null;
            }
            $06091b3cdcba2dc1$var$audioQueue = [];
            $06091b3cdcba2dc1$var$isPlayingAudio = false;
            console.log("Assistant restarted, audio stopped.");
        }
    });
    instance.on({
        type: "receive",
        handler: $06091b3cdcba2dc1$var$handleMessageReceive
    });
    instance.on({
        type: "customResponse",
        handler: $06091b3cdcba2dc1$var$handleFeedbackButtons
    });
    // addLanguageToggle(instance);
    $06091b3cdcba2dc1$var$addRecordButton(instance);
    $06091b3cdcba2dc1$var$addMuteButton(instance);
    instance.updateHomeScreenConfig({
        is_on: false
    });
    $06091b3cdcba2dc1$var$webChatOnLoad(instance);
}
/**
 * Injects a web chat instance into the page.
 */ function $06091b3cdcba2dc1$var$addWebChat() {
    // This is the standard web chat configuration object. You can modify these values with the embed code for your
    // own assistant if you wish to try this example with your assistant. You can find the documentation for this at
    // https://web-chat.global.assistant.watson.cloud.ibm.com/docs.html?to=api-configuration#configurationobject.
    const options = {
        integrationID: "64162f69-c354-4cc5-81c3-5d3f9ea860e3",
        region: "wxo-us-south",
        serviceInstanceID: "703d43ec-866b-4c9c-9a5f-49ecd7b32644",
        onLoad: $06091b3cdcba2dc1$var$onLoad,
        headerConfig: {
            showRestartButton: true
        }
    };
    window.watsonAssistantChatOptions = options;
    const script = document.createElement("script");
    const version = options.clientVersion || "latest";
    script.src = `https://web-chat.global.assistant.watson.appdomain.cloud/versions/${version}/WatsonAssistantChatEntry.js`;
    document.head.appendChild(script);
}
/**
 * This function is called when web chat has been loaded and is ready to be displayed.
 */ async function $06091b3cdcba2dc1$var$webChatOnLoad(instance) {
    instance.on({
        type: "customResponse",
        handler: (event, instance)=>{
            console.log("\uD83D\uDD0D Full Custom Response Event:", event);
            if (event.data.fullMessage.context.skills["actions skill"].skill_variables.table_results.length > 0) {
                (0, $d272bc0fe8ff4605$export$e0f19440971a69f3)(event, instance);
                console.log("event.data:", event.data);
                console.log("ddd -- ", event.data.fullMessage.context.skills["actions skill"].skill_variables.table_results);
            }
        }
    });
    await instance.render();
}
// Launch web chat as soon as this script has loaded.
$06091b3cdcba2dc1$var$addWebChat();


//# sourceMappingURL=index.22afbefd.js.map
